module.exports = __webpack_public_path__ + "static/media/Governmentofkarnataka.b3dba6d0.pdf";